/*
 * Mailcheck https://github.com/mailcheck/mailcheck
 * Author
 * Derrick Ko (@derrickko)
 *
 * License
 * Copyright (c) 2012 Receivd, Inc.
 *
 * Licensed under the MIT License.
 *
 * v 1.1
 */

import _ from 'underscore';


var mailcheck = {
    threshold: 3,
    hardThershold: 1,
    suggestionType: {
        hard: 'hard',
        soft: 'soft'
    },

    defaultDomains: ["yahoo.com", "google.com", "hotmail.com", "gmail.com", "me.com", "aol.com", "mac.com",
        "live.com", "comcast.net", "googlemail.com", "msn.com", "hotmail.co.uk", "yahoo.co.uk",
        "facebook.com", "verizon.net", "sbcglobal.net", "att.net", "gmx.com", "mail.com"],

    run: function (opts) {
        opts.domains = opts.domains || this.defaultDomains;
        opts.distanceFunction = opts.distanceFunction || this.levenshteinDistance;

        var result = this.suggest(encodeURI(opts.email), opts.domains, opts.distanceFunction);

        if (result) {
            if (opts.suggested) {
                opts.suggested(result);
            }
        } else {
            if (opts.empty) {
                opts.empty();
            }
        }
    },

    suggest: function (email, domains, distanceFunction) {
        email = email.toLowerCase();

        var emailParts = this.splitEmail(email);

        var closestDomains = this.findClosestDomain2(emailParts.domain, domains, distanceFunction);

        if (closestDomains) {
            // The email address closely matches; return a suggestion
            var result = [],
                clDomains = closestDomains.domains;
            for (var i = 0; i < clDomains.length; i++) {
                var closestDomain = clDomains[i];
                // result[closestDomain] = emailParts.address + "@" + closestDomain;
                result.push({
                    'domain': closestDomain,
                    'full': emailParts.address + "@" + closestDomain
                });
            }
            return {
                domains: result,
                type: closestDomains.type
            };
        }
        /* The email address exactly matches one of the supplied domains, does not closely
         * match any domain and does not appear to simply have a mispelled top-level domain,
         * or is an invalid email address; do not return a suggestion.
         */
        return false;
    },

    findClosestDomain2: function (domain, domains, distanceFunction) {
        if (!domain || !domains) {
            return false;
        }

        if (_.contains(domains, domain)) {
            return false;
        }

        if (!distanceFunction) {
            distanceFunction = this.levenshteinDistance;
        }

        var dist,
            closestDomains = {};  // {dist: [domain1, domain2, ..., domainN]}

        for (var i = 0; i < domains.length; i++) {
            dist = distanceFunction(domain, domains[i]);

            if (dist > this.threshold) {
                continue;
            }

            if (!(dist in closestDomains)) {
                closestDomains[dist] = [];
            }
            closestDomains[dist].push(domains[i]);
        }

        if (_.isEmpty(closestDomains)) {
            return false;
        }

        // if found only one domain on hard thershold, return it
        if (closestDomains[this.hardThershold] && closestDomains[this.hardThershold].length === 1) {
            return {
                domains: closestDomains[this.hardThershold],
                type: this.suggestionType.hard
            };
        }

        var sortedKeys = _.keys(closestDomains);
        sortedKeys.sort();

        var resultDomains = [];
        _.each(sortedKeys, function (key) {
            resultDomains = _.union(resultDomains, closestDomains[key]);
        });

        return {
            domains: resultDomains,
            type: this.suggestionType.soft
        };
    },

    findClosestDomain: function (domain, domains, distanceFunction) {
        var dist;
        var minDist = 99;
        var closestDomains = [];

        if (!domain || !domains) {
            return false;
        }
        if (!distanceFunction) {
            distanceFunction = this.levenshteinDistance;
        }

        for (var i = 0; i < domains.length; i++) {
            if (domain === domains[i]) {
                return false;
            }
            dist = distanceFunction(domain, domains[i]);

            if (dist < minDist) {
                minDist = dist;
                closestDomains.push(domains[i]);
            } else if (dist === minDist) {
                closestDomains.push(domains[i]);
            }
        }

        if (minDist <= this.threshold && closestDomains.length !== 0) {
            return closestDomains;
        } else {
            return false;
        }
    },
    levenshteinDistance: function (a, b) {
        var bLength = b.length,
            aLength = a.length,
            mathMin = Math.min;

        if (aLength === 0) return aLength;
        if (bLength === 0) return bLength;

        var matrix = [];

        // increment along the first column of each row
        var i;
        for (i = 0; i <= bLength; i++) {
            matrix[i] = [i];
        }

        // increment each column in the first row
        var j;
        for (j = 0; j <= aLength; j++) {
            matrix[0][j] = j;
        }

        // Fill in the rest of the matrix
        for (i = 1; i <= bLength; i++) {
            for (j = 1; j <= aLength; j++) {
                if (b.charAt(i - 1) == a.charAt(j - 1)) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = mathMin(matrix[i - 1][j - 1] + 1, mathMin(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1));
                }
            }
        }
        return matrix[bLength][aLength];
    },
    sift3Distance: function (s1, s2) {
        // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
        if (s1 == null || s1.length === 0) {
            if (s2 == null || s2.length === 0) {
                return 0;
            } else {
                return s2.length;
            }
        }

        if (s2 == null || s2.length === 0) {
            return s1.length;
        }

        var c = 0;
        var offset1 = 0;
        var offset2 = 0;
        var lcs = 0;
        var maxOffset = 5;

        while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
            if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
                lcs++;
            } else {
                offset1 = 0;
                offset2 = 0;
                for (var i = 0; i < maxOffset; i++) {
                    if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
                        offset1 = i;
                        break;
                    }
                    if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
                        offset2 = i;
                        break;
                    }
                }
            }
            c++;
        }
        return (s1.length + s2.length) / 2 - lcs;
    },

    splitEmail: function (email) {
        var parts = email.split('@');

        if (parts.length < 2) {
            return false;
        }

        for (var i = 0; i < parts.length; i++) {
            if (parts[i] === '') {
                return false;
            }
        }

        var domain = parts.pop();
        var domainParts = domain.split('.');
        var tld = '';

        if (domainParts.length == 0) {
            // The address does not have a top-level domain
            return false;
        } else if (domainParts.length == 1) {
            // The address has only a top-level domain (valid under RFC)
            tld = domainParts[0];
        } else {
            // The address has a domain and a top-level domain
            for (var i = 1; i < domainParts.length; i++) {
                tld += domainParts[i] + '.';
            }
            if (domainParts.length >= 2) {
                tld = tld.substring(0, tld.length - 1);
            }
        }

        return {
            topLevelDomain: tld,
            domain: domain,
            address: parts.join('@')
        }
    }
};

if (window.jQuery) {
    (function ($) {
        $.fn.mailcheck = function (opts) {
            var self = this;
            if (opts.suggested) {
                var oldSuggested = opts.suggested;
                opts.suggested = function (result) {
                    oldSuggested(self, result);
                };
            }

            if (opts.empty) {
                var oldEmpty = opts.empty;
                opts.empty = function () {
                    oldEmpty.call(null, self);
                };
            }

            opts.email = this.val();
            mailcheck.run(opts);
        }
    })(jQuery);
}

export default mailcheck;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/clientvalidation/mailcheck.custom.js